import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { COLOR } from "../../../utils/colors";
import { VIEW } from "../../../utils/breakpoint";
import CreateBuildingForm from "../buildings/_form/create";
import { useNavigate } from "react-router-dom";

export default function CreateBuildingPage({
  onSuccess
}: {
  onSuccess?: (buildingId: string) => void
}) {
  const navigate = useNavigate()

  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 600,
            color: COLOR.neutral[900]
          }}
        >
          Create New Building
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: COLOR.neutral[900],
            opacity: 0.6,
          }}
        >
          Please help to fill in the blanks regarding building details
        </Typography>
        <Box sx={(theme) => ({
          display: 'flex',
          gap: '12px',
          marginTop: '24px',
          [theme.breakpoints.down(VIEW.TABLET)]: {
            flexDirection: 'column'
          }
        })}>
          <CreateBuildingForm onSuccess={(buildingId) => onSuccess?.(buildingId)} />
        </Box>
      </Box>
    </Box>
  )
}